import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 権限情報の検索
 */
export function SearchUserRole(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchUserRole,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 権限情報の変更
 */
export function UpdateUserRole(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateUserRole,data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


